import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const ecoPaymentService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/eco-payment/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching eco payment list", error);
            throw error;
        }
    },

    async findById(id: string): Promise<any> {
        try {
            if (id == "add") {
                return null;
            }

            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/eco-payment/findById/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error findById eco payment", error);
            throw error;
        }
    },

    async save(item: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/eco-payment/save`,
                item
            );
            return response.data;
        } catch (error) {
            console.error("Error save eco payment", error);
            throw error;
        }
    },

    async uploadFile(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/eco-payment/upload-file`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error upload eco payment", error);
            throw error;
        }
    },

    async deleteById(id: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/eco-payment/deleteById/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById eco payment", error);
            throw error;
        }
    },
}

export default ecoPaymentService;